var $7fa23663d4de476d$exports = {};
$7fa23663d4de476d$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}`
};


export {$7fa23663d4de476d$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
